module.exports = __webpack_public_path__ + "media/application/images/unesco-new-logo-48a8a1e85e8f78044f7a35fe90d7925593bd3c03d9a8810a427910d6057fca76.svg";